import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";
import TagsService from "external-services/tags-service";
import AdminService from "external-services/diary-admin-service/admin.service";

const NS = 'MenuOptionEditCtrl';
// import {PricingTypes} from "shared-types/index";

export default function MenuOptionsCtrl(
  $scope, $state, $stateParams, $mdToast,
  appConstants, hardCodedTags, unregister, $filter
) {
  "ngInject";

  let vm = this;
  let listeners;

  // status
  vm.mode = null; // 'new' || 'edit'
  vm.loading = false;
  vm.error = null;
  vm.paymentTypes = appConstants.Payment.PaymentTypes; // All payment types
  vm.CheckDuplicates = CheckDuplicates;
  vm.duplicatename = false;
  // model
  vm.item = null;
  vm.tags = [];

  // to trigger usages check (not needed anymore as it is read-only in 'edit' mode)
  // vm.originalPaymentType = null;

  // properties
  vm.providers = [{
    value: appConstants.Providers.NBI,
    label: 'Now BookIt'
  },
    {
      value: appConstants.Providers.EPO,
      label: 'Easy PreOrder'
    }
  ];

  vm.selectablePaymentTypes = [
    appConstants.Payment.PaymentTypes.NoPayment,
    appConstants.Payment.PaymentTypes.Deposit,
    appConstants.Payment.PaymentTypes.FullPayment,
    appConstants.Payment.PaymentTypes.PreAuth
  ].map(function (type) {
    return {
      value: type,
      label: $filter('paymentTypeLabelFilter')(type),
    };
  });

  // methods
  vm.cancel = cancel;
  vm.save = save;
  vm.getIsDeliveryOption = getIsDeliveryOption;

  vm.$onInit = () => {
    listeners = [];
    setDeliveryValues();
    listeners.push($scope.$watchCollection('vm.tags', () => {
      setDeliveryValues();
    }));

    init();
  }

  /**
   * Lifecycle hook.
   * Unfortunately can't use vm.$onDestroy because we're using a `controller`, not a `component`.
   * And we can't use `component` with current version of ui-router.
   */
  $scope.$on('$destroy', () => {
    unregister(listeners);
  });

  function init() {

    vm.isTakeAwayMode = AdminService.getVenue().isTakeAwayMode;

    // Create new or load
    if (!$stateParams.id) {
      vm.mode = 'new';
      vm.item = {
        provider: appConstants.Providers.NBI,
        isStandaloneItem: true,
        childMenuOptions: [],
        explicitChildMenuOptions: []
      };
      vm.tags = [];
    } else {
      vm.mode = 'edit';
      vm.loading = true;
      BookingOptionsManagerService.getById($stateParams.id).then(function (item) {
        if (!item.provider) {
          item.provider = appConstants.Providers.NBI;
        }
        if (typeof item.isStandaloneItem === 'undefined' || vm.isDeliveryOption) {
          item.isStandaloneItem = true;
        }
        vm.item = item;
        // vm.item.pricingType = vm.item.pricingType  || PricingTypes.PerPax;
        if (vm.item.tag) {
          TagsService.getTagById(vm.item.tag).then(function (tag) {
            vm.tags = [tag];
          });
        }
        if (vm.item.childMenuOptionIds) {
          vm.item.childMenuOptions = vm.item.childMenuOptionIds.map(id => ({name: '', _id: id}))
        } else {
          vm.item.childMenuOptions = [];
        }

        if (vm.item.explicitChildMenuOptionIds) {
          vm.item.explicitChildMenuOptions = vm.item.explicitChildMenuOptionIds.map(id => ({name: '', _id: id}))
        } else {
          vm.item.explicitChildMenuOptions = [];
        }
        // vm.originalPaymentType = vm.item.paymentType;
        vm.loading = false;
      }).catch(function (e) {
        vm.loading = false;
        vm.error = e;
      });
    }
  }

  function CheckDuplicates(name) {

    BookingOptionsManagerService.getAll().then(function (items) {
      vm.menuOptions = items;

      if (items != null) {
        for (var i in items) {

          if (name === items[i].name)
          {
            vm.duplicatename = true;
            break;

          }
          else
          {
            vm.duplicatename = false;

          }
        }
      }
      vm.loading = false;
    }).catch(function (e) {
      vm.error = e;
      vm.loading = false;
    });
  }

  function getIsDeliveryOption() {
    return !vm.tags.length ? false : vm.tags[0]._id === hardCodedTags.DELIVERY_TAG_ID;
  }

  function setDeliveryValues() {
    vm.isDeliveryOption = vm.tags.length ? vm.isDeliveryOption = getIsDeliveryOption() : false;
    if (vm.isDeliveryOption) {
      vm.item.isStandaloneItem = true;
    }
  }

  function cancel() {
    $state.go('settings.menuoptions');
  }

  function save(evt, isValid) {
    vm.error = null;
    if (vm.duplicatename == true) {
      vm.displayErrors = true;
      return;
    }
    if (!isValid) {
      vm.displayErrors = true;
      return;
    }

    // checkInUse(evt).then(function (inUse) {
    // if (!inUse) {
    vm.item.tag = vm.tags.length > 0 ? vm.tags[0]._id : null;
    if (vm.item.paymentType === appConstants.Payment.PaymentTypes.NoPayment) {
      vm.item.price = 0;
    }

    convertChildMenuOptionsToIds(false);
    convertChildMenuOptionsToIds(true);

    if (!vm.item.isStandaloneItem || vm.isDeliveryOption) {
      vm.item.childMenuOptionIds = [];
    }

    vm.loading = true;
    BookingOptionsManagerService.save(vm.item).then(function () {
      vm.loading = false;
      $mdToast.show(
        $mdToast.simple()
          .content('Booking Option Saved')
          .position('bottom right')
          .theme('saved')
          .hideDelay(3000)
      );
      $state.go('settings.menuoptions');
    }).catch(function (e) {
      vm.error = e;
      vm.loading = false;
    });
  }

  /**
   * Converts either childMenuOptions or explicitChildMenuOptions into ids list for back end request
   */
  function convertChildMenuOptionsToIds(isExplicit) {
    const idsPropName = isExplicit ? 'explicitChildMenuOptionIds' : 'childMenuOptionIds';
    const propName = isExplicit ? 'explicitChildMenuOptions' : 'childMenuOptions';
    if (vm.item[propName] && vm.item[propName].length) {
      vm.item[idsPropName] = vm.item[propName].map(o => {
        return o._id;
      });
    } else {
      vm.item[idsPropName] = [];
    }

    // don't need whole object when saving to back end, just ids list
    delete vm.item[propName];
  }

  /*
  function checkInUse(evt) {
    return $q(function (resolve) {
      if (vm.originalPaymentType && vm.originalPaymentType !== vm.item.paymentType) {
        $q.all([scheduleService.getDaySchedules(), eventsService.getEventsFromDate()]).then(function (res) {
          var schedules = res[0];
          var events = res[1];
          var uses = menuOptionInUse(vm.item, schedules, events);
          if (uses.length) {
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title('Save Failed')
              .htmlContent('This Booking Option is in use. Please remove it from all your schedules and events before editing.<br><br>It\'s used in the following places:<br>- ' + uses.join('<br>- '))
              .ariaLabel('Save Failed')
              .ok('OK')
              .targetEvent(evt)
            );
            resolve(true);
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    });
  }
*/

  /*
    function menuOptionInUse(menuOption, schedules, events) {
      var results = [];
      var isInUse;
      var optionId;

      for (var s1 in schedules) {
        isInUse = false;
        var schedule = schedules[s1];
        for (var s2 in schedule.services) {
          var service = schedule.services[s2];
          if (service.paymentDetails && service.paymentDetails.paymentType === appConstants.Payment.PaymentTypes.MenuOptions) {
            for (var s3 in service.paymentDetails.menuOptions) {
              optionId = service.paymentDetails.menuOptions[s3];
              if (optionId === menuOption._id) {
                isInUse = true;
                results.push('Schedule for ' + schedule.dayName);
                break;
              }
            }
          }
          if (isInUse) {
            break;
          }
        }
      }

      for (var e1 in events) {
        var event = events[e1];
        if (event.paymentDetails && event.paymentDetails.paymentType === appConstants.Payment.PaymentTypes.MenuOptions) {
          for (var e2 in event.paymentDetails.menuOptions) {
            optionId = event.paymentDetails.menuOptions[e2];
            if (optionId === menuOption._id) {
              isInUse = true;
              results.push('Event for ' + event.name);
              break;
            }
          }
        }
      }

      return results;
    }
  */
}
